import { Link } from 'react-router-dom'
import { useSession } from '../../store/user.store'
import { useEntitlements } from '../../hooks/use-entitlements'

export function TopBar() {
  const user = useSession((s) => s.user)
  const ent = useEntitlements()
  const isPremium = ent.data?.isPremium === true
  const periodEnd = ent.data?.currentPeriodEnd
  const tooltip = isPremium && periodEnd
    ? `Premium · до ${new Date(periodEnd).toLocaleDateString()}`
    : user?.name ?? 'Профиль'

  return (
    <header className="sticky top-0 z-20 border-b border-sage-200/40 bg-cream/85 px-4 py-3 backdrop-blur">
      <div className="mx-auto flex max-w-md items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/icons/logo.png"
            alt=""
            aria-hidden="true"
            className="h-8 w-8 select-none"
            draggable={false}
          />
          <span className="font-serif text-xl text-sage-800">Ядвига</span>
        </Link>
        {user && (
          <Link
            to="/profile"
            className="flex items-center gap-1.5 rounded-full bg-sage-100/70 px-3 py-1 text-sm text-sage-800 transition hover:bg-sage-200/80"
            title={tooltip}
          >
            {isPremium && (
              <img
                src="/icons/premium.png"
                alt=""
                aria-hidden="true"
                className="h-4 w-4 shrink-0 select-none"
                draggable={false}
              />
            )}
            <img
              src="/icons/profile.png"
              alt=""
              aria-hidden="true"
              className="h-4 w-4 shrink-0 select-none"
              draggable={false}
            />
            <span className="max-w-[110px] truncate">{user.name ?? '—'}</span>
          </Link>
        )}
      </div>
    </header>
  )
}
